import { formatDocument, formatToReal } from "../../../utils/utils";

const QuadroSocietario = ({ socios, temIndicadorDebito = true }) => {
  const renderValor = (valor) =>
    valor != null && valor !== "0" ? (
      <span className="text-rose-600 font-semibold">{formatToReal(valor)}</span>
    ) : null;

  const isEmpty = (val) => val == null || val === "" || val === "-";

  const hasEntrada = socios?.some((s) => !isEmpty(s?.data_entrada));
  const hasParticipacao = socios?.some((s) => !isEmpty(s?.participacao));
  const hasAssina = socios?.some((s) => !isEmpty(s?.assina_empresa));
  const hasDebito =
    temIndicadorDebito && socios?.some((s) => !isEmpty(s?.indicador_debito));
  const hasPendencias =
    temIndicadorDebito &&
    socios?.some((s) => s?.restricoes_documento != null);

  const colCount =
    2 +
    (hasEntrada ? 1 : 0) +
    (hasParticipacao ? 1 : 0) +
    (hasAssina ? 1 : 0) +
    (hasDebito ? 1 : 0) +
    (hasPendencias ? 1 : 0);

  const gridStyle = {
    gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
  };

  return (
    <>
      <div className="mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div
            className="grid gap-3 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500"
            style={gridStyle}
          >
            <div className="col-span-2">Nome</div>
            {hasEntrada && <div className="text-center">Entrada</div>}
            {hasParticipacao && <div className="text-center">Part. (%)</div>}
            {hasAssina && <div className="text-center">Assina?</div>}
            {hasDebito && <div className="text-center">Débitos</div>}
            {hasPendencias && <div>Pendências</div>}
          </div>
        </div>

        {socios?.length > 0 && (
          <div className="divide-y divide-slate-100">
            {socios?.map((socio, index) => (
              <div
                key={index}
                className={`grid gap-3 px-4 py-3 text-sm items-center ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                } hover:bg-slate-50`}
                style={gridStyle}
              >
                <div className="col-span-2">
                  <div className="font-medium text-slate-900">
                    {socio?.nome_empresa || "-"}
                  </div>
                  <div className="text-[11px] text-slate-500">
                    CPF/CNPJ:{" "}
                    {socio?.cpf_cnpj ? formatDocument(socio?.cpf_cnpj) : "-"}
                  </div>
                </div>
                {hasEntrada && (
                  <div className="text-center text-slate-700">
                    {socio?.data_entrada || "-"}
                  </div>
                )}
                {hasParticipacao && (
                  <div className="text-center text-slate-700">
                    {socio?.participacao || "-"}
                  </div>
                )}
                {hasAssina && (
                  <div className="text-center text-slate-700">
                    {socio?.assina_empresa || "-"}
                  </div>
                )}
                {hasDebito && (
                  <div className="text-center">
                    <span
                      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] ${
                        socio?.indicador_debito?.toLowerCase() === "sim"
                          ? "border-rose-200 bg-rose-50 text-rose-600"
                          : "border-emerald-200 bg-emerald-50 text-emerald-600"
                      }`}
                    >
                      {socio?.indicador_debito || "-"}
                    </span>
                  </div>
                )}
                {hasPendencias && (
                  <div className="text-[11px] text-slate-600 space-y-1">
                    {socio?.indicador_debito?.toUpperCase() === "SIM" ? (
                      <>
                        {socio?.restricoes_documento?.cheques_sem_fundo
                          ?.quantidade !== "0" && (
                          <div>
                            Cheques sem fundos:{" "}
                            <span className="text-rose-600 font-semibold">
                              {
                                socio?.restricoes_documento?.cheques_sem_fundo
                                  ?.quantidade
                              }{" "}
                              ocorrências
                            </span>
                          </div>
                        )}

                        {socio?.restricoes_documento?.protestos?.quantidade !==
                          "0" && (
                          <div>
                            Protestos:{" "}
                            {renderValor(
                              socio?.restricoes_documento?.protestos?.valor
                            )}
                          </div>
                        )}

                        {socio?.restricoes_documento?.pendencias_restricoes
                          ?.quantidade !== "0" && (
                          <div>
                            Pendências:{" "}
                            {renderValor(
                              socio?.restricoes_documento?.pendencias_restricoes
                                ?.valor
                            )}
                          </div>
                        )}

                        {socio?.restricoes_documento?.acoes_judiciais
                          ?.quantidade !== "0" && (
                          <div>
                            Ações cíveis:{" "}
                            {renderValor(
                              socio?.restricoes_documento?.acoes_judiciais
                                ?.valor
                            )}
                          </div>
                        )}

                        {socio?.restricoes_documento
                          ?.falencias_recuperacao_judicial?.quantidade !==
                          "0" && (
                          <div>
                            Rec. judicial/Falências:{" "}
                            {renderValor(
                              socio?.restricoes_documento
                                ?.falencias_recuperacao_judicial?.valor
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-emerald-600">Não há débitos</div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default QuadroSocietario;
